<template>
  <div class="self_adaption">
    <el-form label-width="96px" label-position="right" class="FormFlex" style="justify-content: space-between;">
      <div class="FormBtn" style="width:100%;display:flex;justify-content:flex-end;">
        <el-button v-show="title.isIssue === 0" size="medium" @click="openDialog('publish')">发布到门户</el-button>
        <el-button v-show="title.isIssue === 1" size="medium" @click="openDialog('disPublish')">取消发布</el-button>
        <el-button size="medium" @click="openDialog('stop')">结束发布会</el-button>
        <el-button size="medium" @click="back()">返回首页</el-button>
      </div>
    </el-form>
    <div class="self_adaption_main" style="background-color: white">
      <div>
        <div class="title centerBtn">
          <div class="first_title_text line_break">{{title.title}}</div>
        </div>
        <div class="title flexSpace" style="margin-top: 0">
          <div class="second_title_text line_break"><b>主办单位：</b>{{title.unit}}</div>
          <div class="second_title_text line_break" style="display: flex;">
            <div style="align-content: center;"><b>发言领导：</b></div>
            <div style="display: flex;align-items: flex-start;justify-content: center;flex-direction: column;text-align: left; width: 79%;">
              <div v-for="(item , index) in title.spokesman" :key="'spokesman'+index" style=" margin-bottom: 5px; line-height: normal">
                {{item}}
              </div>
            </div>
          </div>
          <div class="second_title_text line_break" style="display: flex">
            <div><b>主持人：</b></div>
            <div style="display: flex;align-items: flex-start;justify-content: center;flex-direction: column">
              <div v-for="(item , index) in title.host" :key="'host'+index" style=" margin-bottom: 5px;line-height: normal">
                {{item}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="description">
        <div class="description_left">
          <div class="description_left_2" >
            {{description.intro}}
          </div>
          <div style="color: red;float: right" @click="introDetail">[详情]</div>
          <div class="description_left_3" style="margin-top: 20px">
            <div class="description_left_radius"></div>
            <div>时间：{{description.startTime}}</div>
          </div>
          <div class="description_left_3">
            <div class="description_left_radius"></div>
            <div>地点：{{description.address}}</div>
          </div>
        </div>
        <div class="description_right">
          <el-carousel height="438px">
            <el-carousel-item class="el-car-item" v-for="(item, index) in images" :key="'img'+index">
              <div class="description_right_img">
                <img :src="item.img" alt="" style="width: 100%;height:100%;object-fit: cover;"/>
              </div>
              <div class="description_right_text">
                <div style="margin-left: 35px;font-size: 16px">{{item.title}}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="content">
        <div class="" v-for="(contentData, contentDataTopIndex) in contentDataTop"
             :key="'content' + contentDataTopIndex">
          <div class="content_top" v-for=" (item, contentDataIndex) in contentData"
               :key="'content_top' + contentDataIndex">
            <div class="content_top_1" v-if="contentDataIndex === 0">{{item.speaker}}（{{item.type === 0 ?
              '主持人' : '发言领导'}}）：
            </div>
            <div class="content_top_2" v-html="item.content"><!-- 发言内容 --></div>
            <div class="content_top_3 ">
              <div style="display:flex;justify-content:flex-end;align-items: center;margin-right: 20px"
                   v-show="item.issueStatus === 0">
                <el-button class="content_top_3_button" size="mini" @click="editData('bottom', item)">修改
                </el-button>
                <el-button class="content_top_3_button" type="danger" size="mini"
                           @click="publishSingle(item,'publish')">发布
                </el-button>
              </div>
              <div style="display:flex;justify-content:flex-end;align-items: center;margin-right: 20px"
                   v-show="item.issueStatus === 1">
                <el-button class="content_top_3_button" type="danger" size="mini"
                           @click="publishSingle(item,'disPublish')">取消发布
                </el-button>
              </div>
              <div class="content_top_3_text">{{item.gmtCreate}}</div>
            </div>
          </div>
        </div>
        <div class="content_bottom" v-for="(contentData, contentDataBottomIndex) in contentDataBottom"
             :key="contentDataBottomIndex">
          <div class="content_bottom_1" style="background-color: #f2f2f2" v-if="contentData.speaker">
            <div class="content_bottom_1_top_text">{{contentData.speaker}}：</div>
            <div class="content_bottom_1_bottom_text" v-html="contentData.content"></div>
            <div class="content_top_3">
              <div style="display:flex;justify-content:flex-end;align-items: center;margin-right: 20px"
                   v-show="contentData.issueStatus === 0">
                <el-button class="content_top_3_button" size="mini" @click="editData('bottom', contentData)">修改
                </el-button>
                <el-button class="content_top_3_button" type="danger" size="mini"
                           @click="publishSingle(contentData,'publish')">发布
                </el-button>
              </div>
              <div style="display:flex;justify-content:flex-end;align-items: center;margin-right: 20px"
                   v-show="contentData.issueStatus === 1">
                <el-button class="content_top_3_button" type="danger" size="mini"
                           @click="publishSingle(contentData,'disPublish')">取消发布
                </el-button>
              </div>
              <div class="content_top_3_text">{{contentData.gmtCreate}}</div>
            </div>
          </div>
          <div class="content_bottom_2" v-for="(contentDataChi, contentDataBottomChiIndex) in contentData.children"
               :key="contentDataBottomChiIndex">
            <div class="content_top_1" style="color: #0000BF" v-if="contentDataBottomChiIndex === 0">
              {{contentDataChi.speaker}}<span v-if="contentDataChi.type ===1">（发言领导）</span><span v-else>（主持人）</span> ：
            </div>
            <div class="content_top_2" v-html="contentDataChi.content">

            </div>
            <div class="content_top_3">
              <div style="display:flex;justify-content:flex-end;align-items: center;margin-right: 20px"
                   v-show="contentDataChi.issueStatus === 0">
                <el-button class="content_top_3_button" size="mini" @click="editData('bottom', contentDataChi)">修改
                </el-button>
                <el-button class="content_top_3_button" type="danger" size="mini"
                           @click="publishSingle(contentDataChi,'publish')">发布
                </el-button>
              </div>
              <div style="display:flex;justify-content:flex-end;align-items: center;margin-right: 20px"
                   v-show="contentDataChi.issueStatus === 1">
                <el-button class="content_top_3_button" type="danger" size="mini"
                           @click="publishSingle(contentDataChi,'disPublish')">取消发布
                </el-button>
              </div>
              <div class="content_top_3_text">{{contentDataChi.gmtCreate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑发言内容 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="编辑发言内容"
               :visible.sync="dialogVisibleOne" width="50%">
      <el-table ref="multipleTable" :data="tableDataOne" tooltip-effect="dark" style="width: 100%" border>
        <el-table-column align="center" label="序号" width="60" type="index"></el-table-column>
        <el-table-column align="center" label="发言内容">
          <template slot-scope="scoped">
            <el-input  type="textarea" :autosize="{ minRows: 8, maxRows: 30}" v-model="scoped.row.content" placeholder="请输入发言内容" border="none"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="submitDiv">
        <el-button type="success" @click="submitEdit()">确认</el-button>
        <el-button @click="dialogVisibleOne = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 发布/结束 直播 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="dialogTitle"
               :visible.sync="dialogVisible" width="20%">
      <div style="font-size: 28px;font-weight: 400;text-align: center">{{dialogContent}}</div>
      <div class="submitDiv">
        <el-button type="success" @click="submitDialog(dialogType)">确认</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 介绍详情 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="introDialogTitle"
               :visible.sync="introDialogVisible" width="70%" center>
      <div style="font-size: 18px;font-weight: 400;text-indent:2em;">{{description.intro}}</div>
      <div class="submitDiv" style="justify-content: center">
        <el-button @click="introDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    downLoadApi,
    issueInfoView,
    issueToWeb,
    speechIssue,
    stop,
    surveyquestionsAnswers,
    surveySpeechEditById,
    surveySpeechList,
    surveySpeechSaveSingle
  } from '@/api/axiosUrl';
  import {getYearMonthDay} from '@/utils/jsApi.js'
  import {lineBrake2Dom} from "../utils/tools";

  export default {
    name: 'Progress',
    data() {
      return {
        dataId: '',
        title: {
          isIssue: 0,
          title: '',
          unit: '',
          spokesman: '',
          host: ''
        },
        description: {
          intro: '',
          startTime: '',
          address: ''
        },
        images: [],
        contentDataTop: [],
        contentDataBottom: [],
        dialogVisibleOne: false,
        tableDataOne: [],
        dialogVisible: false,
        dialogTitle: '',
        dialogContent: '',
        dialogType: '',
        introDialogVisible: false,
        introDialogTitle: '',
        introDialogContent: '',
        introDialogType: ''
      };
    },
    created() {
      this.dataId = this.$route.query.id;
      this.init()
    },
    methods: {
      back() {
        this.$router.push('/list');
      },
      //警告提示
      Messager(text, messageType) {
        this.$message({message: text, type: messageType})
      },
      init() {
        this.titleAndDesc()
        this.contentTop()
        this.contentBottom()
      },
      //进入页面去渲染数据
      titleAndDesc() {
        issueInfoView({surveyId: this.dataId}).then(res => {
          if (res.status === 200) {
            this.title.isIssue = res.data.survey.isIssue
            this.title.title = res.data.survey.title
            this.title.unit = res.data.survey.unit
            this.title.host = res.data.host
            this.title.spokesman = res.data.speaker
            this.description.intro = res.data.survey.intro
            this.description.startTime = getYearMonthDay(res.data.survey.startTime, 'yy--mm')
            this.description.address = res.data.survey.address
            res.data.images.forEach(image => {
              downLoadApi({id: image.imgId}).then((res) => {
                this.$set(image, 'urlpath', URL.createObjectURL(new Blob([res], {type: 'image/jpeg'})))
                this.images.push({img: image.urlpath, title: image.name})
              })
            })
          }
        });
      },
      //进入页面去渲染数据
      contentTop() {
        this.contentDataTop = []
        surveySpeechList({surveyId: this.dataId}).then(res => {
          if (!res.data.length) {
            return;
          }
          let arrFlag = res.data[0].groupId
          let arr = []
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].gmtCreate = getYearMonthDay(res.data[i].gmtCreate, 'yy--ss')
            res.data[i].content = lineBrake2Dom(res.data[i].content, "p")
            // 和上次循环属同一个发言人
            if (arrFlag === res.data[i].groupId) {
              arr.push(res.data[i])
              continue
            }
            this.contentDataTop.push(arr)
            arr = [res.data[i]]
            arrFlag = res.data[i].groupId
          }
          this.contentDataTop.push(arr)
        });
      },
      //进入页面去渲染数据
      contentBottom() {
        this.contentDataBottom = []
        surveyquestionsAnswers({surveyId: this.dataId, unEqType: 0}).then(res => {
          if (res.data.length) {
            const parlist = res.data.filter((item) => {
              return item.speechType === 1
            })
            const childlist = res.data.filter((item) => {
              return item.speechType === 2
            })
            parlist.forEach((item) => {
              item.gmtCreate = getYearMonthDay(item.gmtCreate, 'yy--ss')
              item.children = []
              item.content = lineBrake2Dom(item.content, "p")
              childlist.forEach(element => {
                if (element.question === item.id) {
                  element.gmtCreate = getYearMonthDay(element.gmtCreate, 'yy--ss')
                  element.content = lineBrake2Dom(element.content, "p")
                  item.children.push(element)

                }
              });
            })
            this.contentDataBottom = parlist
          }
        });
      },
      editData(flag, data) {
        this.dialogVisibleOne = true
        this.tableDataOne = []
        surveySpeechEditById({id: data.id}).then(res => {
          if (res.status === 200) {
            this.tableDataOne.push(res.data)
          }
        })
      },
      submitEdit() {
        let _this = this
        var params = {
          id: this.tableDataOne[0].id,
          content: this.tableDataOne[0].content
        }
        surveySpeechSaveSingle(params).then(res => {
          if (res.status === 200) {
            this.Messager('修改成功', 'success')
          } else {
            this.Messager('修改失败', 'error')
          }
          setTimeout(function () {
            _this.dialogVisibleOne = false
            _this.init()
          }, 500)
        })
      },
      publishSingle(params, issueStatus) {
        if (issueStatus === 'publish') {
          speechIssue({id: params.id, issueStatus: 1}).then(res => {
            if (res.status === 200) {
              params.issueStatus = 1
              this.Messager('发布成功', 'success')
            } else {
              this.Messager('发布成功', 'error')
            }
          })
        }
        if (issueStatus === 'disPublish') {
          speechIssue({id: params.id, issueStatus: 0}).then(res => {
            if (res.status === 200) {
              params.issueStatus = 0
              this.Messager('取消发布成功', 'success')
            } else {
              this.Messager('取消发布成功', 'error')
            }
          })
        }
      },
      openDialog(type) {
        this.dialogVisible = true
        this.dialogType = type
        if (type === 'stop') {
          this.dialogTitle = '结束会议'
          this.dialogContent = '是否结束本次会议？'
        }
        if (type === 'publish') {
          this.dialogTitle = '发布会议'
          this.dialogContent = '请检查每条发言内容都已按顺序发布！'
        }
        if (type === 'disPublish') {
          this.dialogTitle = '取消发布会议'
          this.dialogContent = '是否取消发布到门户？'
        }
      },
      submitDialog() {
        let _this = this
        if (this.dialogType === 'stop') {
          stop({id: this.dataId}).then(res => {
            if (res.status === 200) {
              this.Messager('结束成功', 'success')
            } else {
              this.Messager('结束失败', 'error')
            }
            setTimeout(function () {
              _this.back()
            }, 500)
          })
        }
        if (this.dialogType === 'publish') {
          issueToWeb({id: this.dataId, issueStatus: 1}).then(res => {
            if (res.status === 200) {
              this.title.isIssue = 1
              this.Messager('发布成功', 'success')
            } else {
              this.Messager('发布成功', 'error')
            }
          })
        }
        if (this.dialogType === 'disPublish') {
          issueToWeb({id: this.dataId, issueStatus: 0}).then(res => {
            if (res.status === 200) {
              this.title.isIssue = 0
              this.Messager('取消发布成功', 'success')
            } else {
              this.Messager('取消发布成功', 'error')
            }
          })
        }
        _this.dialogVisible = false
      },
      introDetail (){
        this.introDialogVisible = true
        this.introDialogTitle = "会议内容"
      }
    }
  };
</script>

<style scoped>
  div {
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';;

  }

  .title {
    /*height: 128px;*/
    margin-top: 21px;
  }

  .first_title_text {
    line-height: 128px;
    font-weight: 700;
    font-style: normal;
    font-size: 32px;
    letter-spacing: normal;
    color: #333333;
  }

  .second_title_text {
    line-height: 128px;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    letter-spacing: normal;
    color: #333333;
    text-align: center;
    width: 100%;
  }

  .line_break {
    //white-space: nowrap;
    text-transform: none;
    padding: 6px;
  }

  .description {
    display: flex;
    padding: 5px;
    border: 1px solid lightgray;
  }

  .description_left {
    flex: 1;
    height: 408px;
    background-color: rgba(247, 247, 247, 1);
    padding: 15px;
  }

  .description_right {
    flex: 2;
    margin-left: 15px;
  }

  .description_left_1 {
    margin-bottom: 20px
  }

  .description_left_button {
    height: 30px;
    font-size: 16px;
    border-radius: 5px;
  }

  .description_left_2 {
    white-space: pre-wrap;
    word-wrap: break-word;
    text-transform: none;
    text-align: left;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    color: #333333;
    font-size: 16px;
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
    font-kerning: normal;
    height: fit-content;
    max-height: 300px;
    line-height: 25px;
    width: 411px;
    display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
    -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-line-clamp: 12; /* 2行，只有 webkit内核支持 */
    word-break: break-all; /* 纯英文换行 */
    overflow: hidden;
  }

  .description_left_3 {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    word-wrap: break-word;
    text-transform: none;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    color: #333333;
    line-height: normal;
    font-size: 20px;
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
  }

  .description_left_radius {
    background-color: #085c9d;
    height: 13px;
    width: 13px;
    border-radius: 10px;
    margin-right: 5px;
  }

  .description_right_img {
    width: 100%;
    height: 435px;
    position: relative;
  }

  .description_right_text {
    z-index: 2;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 56px;
    width: 100%;
    color: white;
    font-size: 18px;
    background-color: rgb(0 0 0 / 46%);
    line-height: 56px;
  }

  .content {
    margin: 10px;
    padding: 10px;
  }

  .content_top {
    border-bottom: #333333 solid 1px;
  }

  .content_top_1 {
    font-weight: 700;
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
    font-kerning: normal;
    word-wrap: break-word;
    text-transform: none;
    font-size: 20px;
    text-align: left;
    letter-spacing: normal;
    color: #333333;
    line-height: normal;
    margin: 30px 30px 0 30px;
  }

  .content_top_2 {
    /*text-indent: 2em;*/
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
    font-kerning: normal;
    word-wrap: break-word;
    text-transform: none;
    font-size: 20px;
    text-align: left;
    letter-spacing: normal;
    color: #333333;
    line-height: 1.5em;
    margin: 10px 30px 0 30px;
    white-space:pre-wrap;
  }

  .content_top_3 {
    margin: 10px 30px 10px 30px;
    display: flex;
    text-align: right;
    justify-content: flex-end;
    align-items: center;
  }

  .content_top_3_button {
    height: 30px;
    width: 90px;
    font-size: 13px;
    border-radius: 5px;
  }

  .content_top_3_text {
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
    font-kerning: normal;
    word-wrap: break-word;
    text-transform: none;
    font-size: 14px;
    text-align: left;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    color: #333333;
    line-height: normal;
    margin-top: 10px;
  }

  .content_bottom_1 {
    margin-top: 5px;
    padding: 10px 0 1px 0;
  }

  .content_bottom_1_top_text {
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
    font-kerning: normal;
    visibility: inherit;
    word-wrap: break-word;
    text-transform: none;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #015478;
    text-align: left;
    letter-spacing: normal;
    line-height: normal;
    margin-left: 33px;
  }

  .content_bottom_1_bottom_text {
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
    font-kerning: normal;
    word-wrap: break-word;
    text-transform: none;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.447058823529412);
    text-align: left;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    margin-left: 33px;
    /*text-indent: 2em;*/
    white-space: pre-wrap;
    word-break: break-word;
  }

  .content_bottom_2 {
    border-bottom: #333333 solid 1px;
  }


</style>
